import React from 'react';

const TransactionTooltip = ({ entry }) => {
    // 1. Guard Clause: If there's no entry, return nothing to avoid the crash
    if (!entry || !entry.postings) {
        return null;
    }

    const interpret = () => {
        const p = entry.postings;

        // Use optional chaining (?.) and fallbacks (|| 0) for extra safety
        const salesAmount = p.find(x => x.account_code === '4100')?.amount || 0;
        const depositUsed = p.find(x => x.account_code === '2410' && x.posting_type === 'debit')?.amount || 0;
        const arAdded = p.find(x => x.account_code === '1050' && x.posting_type === 'debit')?.amount || 0;

        const bankPayment = p.find(x => x.account_code === '1015' || x.account_code === '1000')?.amount || 0;
        const arCleared = p.find(x => x.account_code === '1050' && x.posting_type === 'credit')?.amount || 0;
        const depositAdded = p.find(x => x.account_code === '2410' && x.posting_type === 'credit')?.amount || 0;

        // FEB 1 Logic: Sale involving split payment
        if (salesAmount > 0) {
            if (depositUsed > 0 && arAdded > 0) {
                return `You bought items worth ₦${salesAmount.toLocaleString()}. ₦${depositUsed.toLocaleString()} was paid from your deposit credit, and the remaining ₦${arAdded.toLocaleString()} was added to your debt.`;
            }
            if (depositUsed >= salesAmount) {
                return `You bought items worth ₦${salesAmount.toLocaleString()}, paid fully using your existing deposit credit.`;
            }
            if (arAdded >= salesAmount) {
                return `You bought items worth ₦${salesAmount.toLocaleString()} on credit. This has been added to your balance.`;
            }
        }

        // Payment Logic
        if (bankPayment > 0) {
            let msg = `We received your payment of ₦${bankPayment.toLocaleString()}. `;
            if (arCleared > 0) msg += `₦${arCleared.toLocaleString()} was used to pay off debt. `;
            if (depositAdded > 0) msg += `The remaining ₦${depositAdded.toLocaleString()} was saved as credit.`;
            return msg;
        }

        return entry.description || "Transaction recorded in the ledger.";
    };

    return (
        <div className="p-3 w-64 bg-slate-800 text-white text-xs rounded-lg shadow-xl leading-relaxed border border-slate-700 shadow-2xl">
            <p className="font-semibold mb-1 text-indigo-300">What happened?</p>
            <div className="text-slate-200">
                {interpret()}
            </div>
            {/* Pointer Arrow */}
            <div className="absolute top-2 -right-1 w-2 h-2 bg-slate-800 rotate-45 border-t border-r border-slate-700"></div>
        </div>
    );
};

export default TransactionTooltip;